<div class="container-onlineServices">
    <h3>Servicios en línea</h3>

    <ul>
        <li><a [routerLink]="['/Home/OnlineServices/Consultas']">Consulta en línea ></a></li>
        <li><a [routerLink]="['/Home/OnlineServices/Otros']">Otros servicios digitales ></a></li>
        <li><a [routerLink]="['/Home/OnlineServices/Mapas']">Mapas interactivos ></a></li>
    </ul>
</div>